"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var fields_1 = require("../fields");
var BusinessAreaMultiselectField = /** @class */ (function (_super) {
    __extends(BusinessAreaMultiselectField, _super);
    function BusinessAreaMultiselectField(api, key, label, noSelectionLabel, required, requiredValidationMessage, billableEventId) {
        var _this = _super.call(this, fields_1.FieldType.MultiSelectBusinessAreaDropdown, key, label, required, null, requiredValidationMessage) || this;
        _this.api = api;
        _this.noSelectionLabel = noSelectionLabel;
        _this.billableEventId = billableEventId;
        _this.search = function (searchPhrase) {
            _this._searchPhrase = searchPhrase;
            _this._searchBoxValue = searchPhrase;
            _this.observationProvider.notifyObservers(fields_1.FieldActions.SearchCompleted);
        };
        _this.focused = function () {
            if (_this.isDisabled) {
                return;
            }
            //this._dropdownOpen = true;
            _this._searchBoxValue = '';
            //this.observationProvider.notifyObservers(FieldActions.DropdownOpened);
        };
        _this.blurred = function () {
            //this._dropdownOpen = false;
            _this._searchPhrase = '';
            _this.setSearchBoxValue();
            //this.observationProvider.notifyObservers(FieldActions.DropdownClosed);
        };
        _this.setSearchBoxValue = function () {
            var selectedCount = _this.selectedBusinessAreas.length;
            if (selectedCount === _this._options.filter(function (o) { return o.businessAreaId >= 0; }).length) {
                _this._searchBoxValue = 'All Selected';
            }
            else if (selectedCount > 1) {
                _this._searchBoxValue = selectedCount + ' business ares selected';
            }
            else if (selectedCount === 1) {
                _this._searchBoxValue = _this.selectedBusinessAreas[0].name;
            }
            else if (_this.noSelectionLabel) {
                _this._searchBoxValue = _this._options[0].name;
            }
            else {
                _this._searchBoxValue = '';
            }
        };
        _this.loadOptions = function () { return __awaiter(_this, void 0, void 0, function () {
            var businessAreas, _i, businessAreas_1, businessArea;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.billableEventId) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.api.getBusinessAreasWithDepartments()];
                    case 1:
                        businessAreas = (_a.sent()).map(function (businessArea) {
                            return {
                                businessAreaId: businessArea.id,
                                name: businessArea.name
                            };
                        });
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.api.getEventBillableBusinessAreas(this.billableEventId)];
                    case 3:
                        businessAreas = (_a.sent()).map(function (businessArea) {
                            return {
                                businessAreaId: businessArea.businessAreaId,
                                name: businessArea.name
                            };
                        });
                        _a.label = 4;
                    case 4:
                        if (this.noSelectionLabel) {
                            this._options.push({
                                businessAreaId: -1,
                                name: this.noSelectionLabel,
                                selected: true
                            });
                        }
                        this._options.push({
                            businessAreaId: -2,
                            name: 'Select All'
                        });
                        for (_i = 0, businessAreas_1 = businessAreas; _i < businessAreas_1.length; _i++) {
                            businessArea = businessAreas_1[_i];
                            this._options.push(businessArea);
                        }
                        this.setSearchBoxValue();
                        this._optionsLoaded = true;
                        this.observationProvider.notifyObservers(fields_1.FieldActions.OptionsLoaded);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.observationProvider.observe(_this.focused, fields_1.FieldActions.Focus);
        _this.observationProvider.observe(_this.blurred, fields_1.FieldActions.Blured);
        _this._options = [];
        _this._loadingPromise = _this.loadOptions();
        return _this;
    }
    Object.defineProperty(BusinessAreaMultiselectField.prototype, "options", {
        get: function () {
            return this._options;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BusinessAreaMultiselectField.prototype, "searchPhrase", {
        get: function () {
            return this._searchPhrase;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BusinessAreaMultiselectField.prototype, "searchBoxValue", {
        get: function () {
            return this._searchBoxValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BusinessAreaMultiselectField.prototype, "selectedBusinessAreas", {
        get: function () {
            return this._options.filter(function (option) { return option.selected === true && option.businessAreaId > 0; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BusinessAreaMultiselectField.prototype, "dropdownOpen", {
        get: function () {
            return this.isFocused;
        },
        enumerable: false,
        configurable: true
    });
    BusinessAreaMultiselectField.prototype.isValid = function () {
        var isValid = !this.isRequired || this.selectedBusinessAreas.length > 0;
        this.setIsValid(isValid);
        return isValid;
    };
    Object.defineProperty(BusinessAreaMultiselectField.prototype, "value", {
        get: function () {
            return this.selectedBusinessAreas.map(function (businessArea) { return businessArea.businessAreaId; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BusinessAreaMultiselectField.prototype, "errorMessage", {
        get: function () {
            return this.getErrorMessage();
        },
        enumerable: false,
        configurable: true
    });
    BusinessAreaMultiselectField.prototype.setValue = function (newValue) {
        var _this = this;
        if (this._optionsLoaded) {
            this.proceedSetValue(newValue);
        }
        else {
            this._loadingPromise.then(function () {
                _this.proceedSetValue(newValue);
            });
        }
    };
    BusinessAreaMultiselectField.prototype.proceedSetValue = function (newValue) {
        if (Array.isArray(newValue)) {
            for (var i = 0; i < this._options.length; i++) {
                this.options[i].selected = newValue.indexOf(this.options[i].businessAreaId) >= 0;
            }
        }
        else {
            var numberValue = parseInt(newValue, 10);
            if (!Number.isNaN(numberValue)) {
                this._options.map(function (businessArea) {
                    return businessArea.selected = businessArea.businessAreaId === businessArea.businessAreaId;
                });
            }
        }
        this.setSearchBoxValue();
        this.setStringValueWithSelectedIds();
        this.evaluateForAllSelected();
        this.observationProvider.notifyObservers(fields_1.FieldActions.ValueChanged, this.selectedBusinessAreas);
    };
    BusinessAreaMultiselectField.prototype.setStringValueWithSelectedIds = function () {
        var stringValue = '';
        for (var i = 0; i < this.selectedBusinessAreas.length; i++) {
            stringValue += this.selectedBusinessAreas[i].businessAreaId;
        }
        this.setStringValue(stringValue);
    };
    BusinessAreaMultiselectField.prototype.toggleSelection = function (option) {
        if (this.isDisabled) {
            return;
        }
        if (option.businessAreaId === -1) {
            this.clearValue();
            return;
        }
        if (option.businessAreaId === -2) {
            this.selectAll();
            return;
        }
        if (this.noSelectionLabel) {
            this._options[0].selected = false;
        }
        if (option.selected) {
            option.selected = false;
        }
        else {
            option.selected = true;
        }
        this.evaluateForAllSelected();
        this.isValid();
        this.setStringValueWithSelectedIds();
        this.observationProvider.notifyObservers(fields_1.FieldActions.ValueChanged);
    };
    BusinessAreaMultiselectField.prototype.evaluateForAllSelected = function () {
        var areAllSelected = this.selectedBusinessAreas.length === this._options.filter(function (o) { return o.businessAreaId >= 0; }).length;
        this._options.filter(function (o) { return o.businessAreaId === -2; })[0].selected = areAllSelected;
    };
    BusinessAreaMultiselectField.prototype.selectAll = function () {
        if (this.isDisabled || !this._options.length) {
            return;
        }
        for (var i = 0; i < this._options.length; i++) {
            if (i !== 0 || !this.noSelectionLabel) {
                this._options[i].selected = true;
            }
        }
        //this._dropdownOpen = false;
        this._searchPhrase = '';
        this.setSearchBoxValue();
        this.isValid();
        this.setStringValueWithSelectedIds();
        this.blur();
        this.observationProvider.notifyObservers(fields_1.FieldActions.ValueChanged);
    };
    BusinessAreaMultiselectField.prototype.clearValue = function () {
        if (this.isDisabled || !this._options.length) {
            return;
        }
        for (var _i = 0, _a = this._options; _i < _a.length; _i++) {
            var option = _a[_i];
            option.selected = false;
        }
        if (this.noSelectionLabel) {
            this._options[0].selected = true;
        }
        this._searchPhrase = '';
        this.setSearchBoxValue();
        this.isValid();
        this.setStringValueWithSelectedIds();
        this.blur();
        this.observationProvider.notifyObservers(fields_1.FieldActions.ValueChanged);
    };
    return BusinessAreaMultiselectField;
}(fields_1.BaseField));
exports.default = BusinessAreaMultiselectField;
